<template>
  <BaseSelect
    v-model="value"
    :options="planOptions"
    name="plan"
    class="w-full"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useSubscriptions } from '~/stores/subscriptions'
import { useAuth } from '~/stores/auth'

const i18n = useI18n()

const props = defineProps({
  modelValue: {
    type: Number,
    default: undefined,
  },
})

const emit = defineEmits(['update:modelValue'])
const authStore = useAuth()
const subscriptionsStore = useSubscriptions()

const planOptions = computed(() => {
  return subscriptionsStore.plans.map((plan) => {
    const name = getFieldLocale(plan.name, i18n.locale.value)
    const onlyForAdmins = plan.is_visible ? '' : ' [visible only for admins]'

    return {
      label: `${name} (ID: ${plan.id})${onlyForAdmins}`,
      value: plan.id,
    }
  })
})

const value = computed({
  get: () => {
    return props.modelValue
  },
  set: (value) => {
    emit('update:modelValue', value)
  },
})

onMounted(async () => {
  await subscriptionsStore.fetchPlansList(
    !!authStore.profile,
    authStore.isAdmin
  )
})
</script>
